import {
  PATIENT_DOCUMENT_DESCRIPTIONS,
  PATIENT_DOCUMENT_NAMES,
  TRACK_EVENTS,
} from "core/consts";
import { PatientDocumentType, TrackEventFn } from "core/types";
import { onPremHttpRequest } from ".";

export function postPatientDocument({
  careseekerName,
  documentType,
  encodedPdf,
  externalId,
  on_premise_authorization_token,
  on_premise_domain_ssl,
  responseId,
  targetHTML,
  trackEvent,
  userId,
}: {
  careseekerName: string;
  documentType: PatientDocumentType;
  encodedPdf: string;
  externalId: string;
  on_premise_authorization_token: string | undefined;
  on_premise_domain_ssl: string;
  responseId?: string;
  targetHTML: string;
  trackEvent: TrackEventFn;
  userId: string;
}): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const trackImport = (status: number) => {
      trackEvent({
        endpoint: on_premise_domain_ssl,
        name: TRACK_EVENTS.HL7_FILE_EXPORT,
        status,
      });
    };

    let content = "";
    try {
      content = btoa(targetHTML); // Base64 encode the HTML string
    } catch (_error) {
      trackImport(-2);
      reject("Encoding failed");
      return;
    }

    const documentName = `${[
      PATIENT_DOCUMENT_NAMES[documentType],
      responseId,
      userId,
    ]
      .truthy()
      .join("_")}`;
    const documentDescription = `${PATIENT_DOCUMENT_DESCRIPTIONS[documentType]}`;

    onPremHttpRequest({
      body: JSON.stringify({
        careseeker_name: careseekerName
          .replaceAll("ä", "ae")
          .replaceAll("ö", "oe")
          .replaceAll("ü", "ue")
          .replaceAll(" ", "_"),
        content,
        content_pdf: encodedPdf,
        document_description: documentDescription,
        document_name: documentName,
        document_type: documentType,
        patient_id: userId,
      }),
      method: "POST",
      on_premise_authorization_token,
      on_premise_domain_ssl,
      path: `patient/${externalId}/document`,
    })
      .then((response) => {
        trackImport(response.status);
        if (!response.ok) {
          reject(new Error(`Gateway error: ${response.status}`));
        } else {
          resolve(documentName);
        }
      })
      .catch((err) => {
        trackImport(-1);
        console.error(`Isik transfer type ${documentType} error`, err);
        reject(err);
      });
  });
}
